<template>

        <div class="col-12">
            
            <!--<div class="tabs-wrapper mb-100" data-brk-library="component__steps">
                <div class="steps__wrapper-main steps__wrapper-checkers">
                    <div class="steps__progress"></div>
                    <ul class="steps__wrapper tabs" data-tabgroup="tab-group-5">
                        <li class="complete">
                            <a href="#" @click="changeView('registration')">
                                        <span class="font__family-montserrat font__weight-bold font__size-15 steps__dot">
                                            <span class="before"></span>
                                            <span class="after"></span>
                                            1
                                        </span>
                                <p class="font__family-montserrat font__size-15 steps__title">Registracija</p>
                            </a>
                        </li>
                        <li class="complete">
                            <a href="#" @click="changeView('payment')">
                                        <span class="font__family-montserrat font__weight-bold font__size-15 steps__dot">
                                            <span class="before"></span>
                                            <span class="after"></span>
                                            2
                                        </span>
                                <p class="font__family-montserrat font__size-15 steps__title">Plaćanje</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                        <span class="font__family-montserrat font__weight-bold font__size-15 steps__dot">
                                            <span class="before"></span>
                                            <span class="after"></span>
                                            3
                                        </span>
                                <p class="font__family-montserrat font__size-15 steps__title">Završetak narudžbe</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>-->
    
            <div v-if="view == 'registration'" class="col-12 mb-50 mt-50">
    
                <!--
                <div class="d-flex justify-content-center mb-50">
                    <button href="" v-model="type" @click="changeType('single')"
                            class="btn btn-gradient btn-lg border-radius-10 font__family-open-sans font__weight-bold brk-white-font-color btn-min-width-200"
                            data-brk-library="component__button">
                        <i class="fa fa-user icon-inside" aria-hidden="true"></i>
                        <span>INDIVIDUALCI (do 10) </span>
                    </button>
    
                    <button href="" v-model="type" @click="changeType('group')"
                            class="btn btn-gradient btn-lg border-radius-10 font__family-open-sans font__weight-bold brk-white-font-color btn-min-width-200"
                            data-brk-library="component__button">
                        <i class="fa fa-users icon-inside" aria-hidden="true"></i>
                        <span> GRUPE (10+)</span>
                    </button>
                </div>
    -->
    
                <div v-if="type === 'single'" v-for="(user, key) in users" class="mt-50">
    
                    <h4 class="title__divider title__divider--line font__size-21 font__weight-bold font__family-montserrat line__height-24 text-left"
                        data-brk-library="component__dividers">
                        <span class="title__divider__wrapper">Racer {{ key + 1 }}
    
                            <button class="btn btn-xs btn-danger  border-radius-25 font__family-open-sans font__weight-bold"
                                    @click="removeUser(user)"
                                    v-if="key">
                                <i class="fa fa-fw fa-times"></i></button>
                            <span class="line brk-base-bg-gradient-right"></span></span></h4>
    
    
                    <div class="row mt-40 mb-3">
    
    
                        <div class="col-md-3">
                            <strong v-if="errors['users.'+key+'.first_name'] "></strong>
                            <input type="text"
                                   :placeholder="$t('message.first_name')"
                                   v-model="user.first_name"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.first_name'] }"
                                   required>
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.first_name']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
    
                                   :placeholder="$t('message.last_name')"
                                   v-model="user.last_name"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.last_name'] }"
                                   required>
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.last_name']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <datetime v-model="user.date_of_birth"
                                      class="form-control"
                                      input-class="form-control"
                                      format="dd.MM.yyyy"
                                      :placeholder="$t('message.date_of_birth')"
                                      @input="checkAge(user)"
                                      required
                            >
                            </datetime>
    
                            <div v-show="errors['users.'+key+'.date_of_birth']" class="invalid">
                                <strong v-for="error in  errors['users.'+key+'.date_of_birth']"> {{ error }}</strong>
                            </div>
                        </div>
    
                        <div class="col-md-3">
    
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox1" v-model="user.gender"
                                       value="male">
                                <label class="form-check-label" for="inlineCheckbox1">{{ $t('message.male') }}</label>
                            </div>
    
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="inlineCheckbox2" v-model="user.gender"
                                       value="female">
                                <label class="form-check-label" for="inlineCheckbox2">{{ $t('message.female') }}</label>
                            </div>
    
                            <div v-show="errors['users.'+key+'.gender']" class="invalid">
                                <strong v-for="error in  errors['users.'+key+'.gender']"> {{ error }}</strong>
                            </div>
    
                        </div>
                    </div>
    
                    <div class="row mt-3">
                        <div class="col-md-3">
    
                            <v-select v-model="user.country_id"
                                      :value="countries[56]"
                                      label="name"
                                      class="form-control"
                                      :placeholder="$t('message.state')"
                                      :options="countries"
                                      :class="{ 'is-invalid': errors['users.'+key+'.country_id'] }"
                                      :reduce="countries => countries.id"
                                      :required="user.country_id"
                            >
                            </v-select>
    
                            <div v-show="errors['users.'+key+'.country_id']" class="invalid">
                                <strong v-for="error in  errors['users.'+key+'.country_id']"> {{ error }}</strong>
                            </div>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   :placeholder="$t('message.city')"
                                   class="form-control"
    
                                   :class="{ 'is-invalid': errors['users.'+key+'.city'] }"
                                   v-model="user.city"
                                   required>
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.city']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.postal'] }"
                                   v-model="user.postal"
                                   :placeholder="$t('message.postal')"
                                   required>
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.postal']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
    
    
                            <select name="tshirt" class="form-control" v-model="user.shirt_size">
                                <option value="" disabled>Veličina majice</option>
                                <option value="XS">XS</option>
                                <option value="S">S</option>
                                <option value="M">M</option>
                                <option value="L">L</option>
                                <option value="XL">XL</option>
                                <option value="XXL">XXL</option>
                            </select>
    
                            <div v-show="errors['users.'+key+'.shirt_size']" class="invalid">
                                <strong v-for="error in errors['users.'+key+'.shirt_size']"> {{ error }}</strong>
                            </div>
    
                        </div>
                    </div>
    
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <input type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.club'] }"
                                   v-model="user.club"
                                   :placeholder="$t('message.club_name')">
    
                            <div v-show="errors['users.'+key+'.club']" class="invalid">
                                <strong v-for="error in errors['users.'+key+'.club']"> {{ error }}</strong>
                            </div>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.emergency_contact'] }"
                                   v-model="user.emergency_contact"
                                   :placeholder="$t('message.emergency_contact')">
    
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.emergency_contact']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="email"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.email'] }"
                                   v-model="user.email"
                                   :placeholder="$t('message.email')">
    
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.email']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.phone'] }"
                                   v-model="user.phone"
                                   :placeholder="$t('message.phone')"
                            >
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.phone']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-6 mt-5">
    
                            <multiselect v-model="user.products"
                                         :options="products"
                                         :multiple="true"
                                         :close-on-select="false"
                                         :clear-on-select="false"
                                         :preserve-search="true"
                                         :placeholder="$t('message.chose_ticket')"
                                         label="name"
                                         track-by="name"
                                         :option-height="104"
                                         class="form-control"
                            >
                                <template slot="singleLabel" slot-scope="props">
                                    <img class="option__image"
                                         :src="'http://localhost:3000/storage/' + props.option.image"
                                         width="100px">
    
                                    <span class="option__desc">
                                        <span class="option__title">{{ props.option.title }} <br> {{ props.option.price}}</span>
                                    </span>
                                </template>
    
                                <template slot="option" slot-scope="props">
                                    <img class="option__image"
                                         :src="'http://localhost:3000/storage/' + props.option.image"
                                         width="100px">
    
                                    <div class="option__desc">
                                        <span class="option__title">{{ props.option.name }}  <br> {{ props.option.price}} Kn</span>
                                    </div>
                                </template>
                            </multiselect>
    
                            <br>
    
                            <div v-show="errors['users.'+key+'.products']" class="invalid">
                                <strong v-for="error in errors['users.'+key+'.products']"> {{ error }}</strong>
                            </div>
                        </div>
    
    
                    </div>
    
                    <div class="row" id="starci" v-show="user.minor">
    
                        <div class="col-md-3">
                            <input type="text"
                                   placeholder="Ime roditelja"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.parents.first_name'] }"
                                   v-model="user.parents.first_name">
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.parents.first_name']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   class="form-control"
                                   placeholder="Prezime roditelja"
                                   :class="{ 'is-invalid': errors['users.'+key+'.parents.last_name'] }"
                                   v-model="user.parents.last_name">
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.parents.last_name']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="email"
                                   :placeholder="$t('message.email')"
                                   class="form-control"
                                   :class="{ 'is-invalid': errors['users.'+key+'.parents.email'] }"
                                   v-model="user.parents.email">
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.parents.email']"> {{ error }}</strong>
                        </span>
                        </div>
    
                        <div class="col-md-3">
                            <input type="text"
                                   :placeholder="$t('message.phone')"
                                   :class="{ 'is-invalid': errors['users.'+key+'.parents.phone'] }"
                                   class="form-control"
                                   v-model="user.parents.phone">
                            <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['users.'+key+'.parents.phone']"> {{ error }}</strong>
                        </span>
                        </div>
                    </div>
    
                </div>
    
                <div class="row" id="step3" v-if="type === 'group'">
                    <div class="col-md-3">
                        <h1>GRUPA</h1>
                    </div>
                </div>
    
    
    
                <h4 class=" mt-40  mb-40 title__divider title__divider--line font__size-21 font__weight-bold font__family-montserrat line__height-24 text-left"
                    data-brk-library="component__dividers">
                        <span class="title__divider__wrapper">POLL
    
                            <span class="line brk-base-bg-gradient-right"></span></span>
                </h4>
    
                <div class="row" id="poll" v-if="this.users[0].country_id != 56 || !this.users[0].postal.startsWith('20')">
    
                    <div class="col-md-3">
    
                        <datetime v-model="poll.arrival_date"
                                  input-class="form-control"
                                  format="dd.MM.yyyy"
                                  :placeholder="$t('message.arrival_date')"
                                  requred>
                        </datetime>
                        <div v-show="errors['poll.arrival_date']" class="invalid">
                            <strong v-for="error in errors['poll.arrival_date']"> {{ error }}</strong>
                        </div>
    
                    </div>
    
                    <div class="col-md-3">
                        <datetime v-model="poll.departure_date"
                                  class="form-control"
                                  input-class="form-control"
                                  format="dd.MM.yyyy"
                                  :placeholder="$t('message.departure_date')">
                        </datetime>
    
                        <div v-show="errors['poll.arrival_date']" class="invalid">
                            <strong v-for="error in errors['poll.departure_date']"> {{ error }}</strong>
                        </div>
    
                    </div>
    
                    <div class="col-md-3">
    
    
                        <select name="transport" class="form-control" v-model="poll.transport">
                            <option value="" disabled> {{ $t('message.transport') }}</option>
                            <option value="airplane">Avion</option>
                            <option value="boat">Brod</option>
                            <option value="bus">Autobus</option>
                            <option value="car">Auto</option>
                            <option value="other">Ostalo</option>
                        </select>
    
    
                        <div v-show="errors['poll.arrival_date']" class="invalid">
                            <strong v-for="error in errors['poll.transport']"> {{ error }}</strong>
                        </div>
                    </div>
    
    
                    <div class="col-md-3">
                        <select name="accomodation" class="form-control" v-model="poll.accommodation">
                            <option value="" disabled>Smještaj</option>
                            <option value="hotel">Hotel</option>
                            <option value="private">Privatni smještaj</option>
                            <option value="camp">Kamp</option>
                            <option value="family">Obitelj i prijatelji</option>
                            <option value="other">Ostalo</option>
                        </select>
    
    
                        <div v-show="errors['poll.arrival_date']" class="invalid">
                            <strong v-for="error in errors['poll.accommodation']"> {{ error }}</strong>
                        </div>
                    </div>
    
                </div>
    
                <div class="row mt-3 mb-2"
                     v-if="this.users[0].country_id != 'Croatia' || !this.users[0].postal.startsWith('20')">
                    <div class="col-md-3">
                        <input type="text"
                               class="form-control"
                               :class="{ 'is-invalid': errors['poll.passengers'] }"
                               v-model="poll.passengers"
                               :placeholder="$t('message.passengers')"
                        >
    
                        <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['poll.passengers']"> {{ error }}</strong>
                        </span>
                    </div>
    
                    <div class="col-md-9">
                        <input type="text"
                               class="form-control"
                               :class="{ 'is-invalid': errors['poll.'+key+'.note'] }"
                               v-model="poll.note"
                               :placeholder="$t('message.note')"
                        >
    
                        <span class="invalid-feedback" role="alert">
                            <strong v-for="error in errors['poll.'+key+'.note']"> {{ error }}</strong>
                        </span>
                    </div>
                </div>
    
                <div class="mt-30">
                    <button class="btn btn-prime btn-lg border-radius-25 font__family-open-sans font__weight-bold"
                            @click="register()">
                        <span class="before"></span>
                        <span class="after"></span>
                        <span class="border-btn"></span>Regstracija
                    </button>
    
    
                    <button class="btn btn-prime btn-lg border-radius-25 font__family-open-sans font__weight-bold"
                            @click="addUser()" v-if="users.length < 10">
                        <span class="before"></span>
                        <span class="after"></span>
                        <span class="border-btn"></span> Dodaj trkača <i class="fa fa-fw  fa-plus-circle"></i>
                    </button>
    
                    <strong class="text-danger" v-else> Maksimalno 10 trkača</strong>
                </div>
            </div>
    
    
        </div>
    </template>
    
    <script>
        export default {
            mounted() {
                this.getCountries()
                this.getProducts()
                this.setlang()
            },
            created() {
                Event.$on('chenge-view', (view) => this.changeView(view));
            },
    
            data() {
                return {
                    lang: '',
                    view: 'registration',
                    type: 'single',
                    countries: [],
                    products: [],
                    errors: {},
                    users: [{
                        first_name: '',
                        last_name: '',
                        date_of_birth: '',
                        gender: '',
                        country_id: '',
                        city: '',
                        postal: '',
                        shirt_size: '',
                        club: '',
                        emergency_contact: '',
                        email: '',
                        phone: '',
                        minor: '',
                        products: '',
                        parents: {
                            first_name: '',
                            last_name: '',
                            email: '',
                            phone: '',
                        }
                    }],
    
                    newUser: {
                        first_name: '',
                        last_name: '',
                        date_of_birth: '',
                        gender: '',
                        country_id: '',
                        city: '',
                        postal: '',
                        shirt_size: '',
                        club: '',
                        emergency_contact: '',
                        email: '',
                        phone: '',
                        products: '',
                        parents: {
                            first_name: '',
                            last_name: '',
                            email: '',
                            phone: '',
                        }
                    },
    
                    poll: {
                        arrival_date: '',
                        departure_date: '',
                        transport: '',
                        accommodation: '',
                        passengers: '',
                        note: '',
                    }
                }
            },
    
    
            methods: {
                setlang() {
                    this.$i18n.locale = window.default_locale
                },
    
                // TODO: izbacit
                changeType(type) {
                    this.type = type
                },
    
                changeView(view) {
                    this.view = view
                },
    
                addUser() {
                    let user = this.newUser
                    user.city = this.users[0].city
                    user.postal = this.users[0].postal
                    user.country_id = this.users[0].country_id
                    user.emergency_contact = this.users[0].emergency_contact
                    user.club = this.users[0].club
    
                    this.users.push(Object.assign({}, user));
                },
    
                removeUser(user) {
                    this.users.splice(this.users.indexOf(user), 1);
                },
    
                getCountries() {
                    axios.get('/api/v1/service/countries').then(response => {
                        this.countries = response.data.countries
                    });
                },
    
                getProducts() {
                    axios.get('/api/v1/service/products').then(response => {
                        this.products = response.data.products
                    });
                },
    
                getPrices() {
                    axios.get('/admin/products-prices/' + this.product).then(response => {
                        this.prices = response.data
                    });
                },
    
                checkAge(user) {
                    var today = new Date();
                    var birthDate = new Date(user.date_of_birth);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    this.users[this.users.indexOf(user)].minor = (age <= 16) ? true : false;
                },
    
                register() {
                    axios.post('/api/v1/register', {users: this.users, poll: this.poll})
                        .then((response) => {
                             Event.$emit('order-created', response.data.order)
                            // this.view = 'payment'
    
                             window.location.href = response.data.redirect;
    
                        }, (error) => {
                            this.errors = error.response.data.errors
                        });
                },
    
                remove(price) {
    
                    this.$swal({
                        title: 'Upozorenje!',
                        text: "Jeste li sigurni da želite pobrisati cijenu",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        confirmButtonText: 'Pobriši',
                        cancelButtonText: 'Odustani'
                    }).then((result) => { // <--
                        if (result.value) { // <-- if confirmed
                            axios.delete('/admin/products-prices/' + price).then(response => {
                                console.log(response.data)
                                toastr.error("Uspiješno obrisan.");
                                this.getPrices()
    
                            }).cache(error => {
                                toastr.error("Opaaa.");
                                console.log(response.data.error)
                            });
                        }
                    });
                },
            },
    
            computed: {
                invoiceTotal() {
                    return (this.subTotal - (this.subTotal * parseFloat((this.discount / 100).toFixed(2))));
                }
            }
        }
    </script>
    <style>
    
        .block:nth-child(odd) {
            background-color: #f8f8f8 !important;
        }
    
        .invalid {
            width: 100%;
            margin-top: 0.25rem;
            font-size: 80%;
            color: #e3352f7c;
        }
    
        .invalid-border {
            border-color: #e3342f;
            padding-right: calc(1.6em + 0.75rem);
        }
    
        .multiselect__option--highlight {
            background-color: #497cff;
        }
    
        .option__desc, .option__image {
            display: inline-block;
            vertical-align: middle;
        }
    
        .option__image {
            max-height: 80px;
            margin-right: 10px;
        }
    

    
    
    </style>
    
    
    